import * as React from "react";
import {Conductor, LiveStreamConductorStatus} from "../../models/conductor";
import {Button, Divider, Modal, Table} from "antd";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import Message from "../../constants/message";
import {NavLink} from "react-router-dom";
import {PaginationDefaultParams} from "../custom/Paginator";
import FormattedDateTime from "../../components/custom/FormattedDateTime";


type Props = {
  data: Conductor[];
  loading: boolean;
  deleteFn: (item: Conductor) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const ConductorsTable: React.FC<Props> = props => {
  const {data, loading, currentPage, deleteFn, intl} = props;
  const {formatMessage} = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;

  const deleteConductor = (item: Conductor): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete"
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel"
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item)
    });
  };

  const handleStatusTitle = (status: LiveStreamConductorStatus) => {
    switch (status) {
      case LiveStreamConductorStatus.stream_ended_automatically:
        return "اتمام (اتوماتیک)";
      case LiveStreamConductorStatus.stream_ended_manually:
        return "اتمام (دستی)";
      case LiveStreamConductorStatus.stream_started_automatically:
        return "شروع (اتوماتیک)";
      case LiveStreamConductorStatus.stream_started_manually:
        return "شروع (دستی)";
      case LiveStreamConductorStatus.stream_paused_manually:
        return "اتمام (اتوماتیک)";
      case LiveStreamConductorStatus.waiting_for_start_stream_date:
        return "حالت اتوماتیک";
    }
  };

  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      align: "center",
      width: 30,
      dataIndex: "index",
      key: "id",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
      align: "center",
      width: 50,
      dataIndex: "title",
      key: "title"
    },
    {
      title: <FormattedMessage id="app.video_content" defaultMessage={`ٰVideo Content`}/>,
      align: "center",
      width: 50,
      dataIndex: "video_content",
      key: "video_content",
      render: (video_content) => {
        return (<NavLink to={`/video-contents/${video_content.id}/edit`}>{video_content.title}</NavLink>);
      }
    },
    {
      title: <FormattedMessage id="app.channel" defaultMessage={`Channel`}/>,
      align: "center",
      width: 50,
      dataIndex: "channel",
      key: "channel",
      render: (channel) => channel.title
    },
    {
      title: (
        <FormattedMessage
          id="app.create_date"
          defaultMessage={`Create Date`}
        />
      ),
      align: "center",
      width: 100,
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => <FormattedDateTime date={created_at}/>
    },
    {
      title: (
        <FormattedMessage
          id="app.start_date"
          defaultMessage={`Start Date`}
        />
      ),
      align: "center",
      width: 100,
      dataIndex: "start_stream_time",
      key: "start_stream_time",
      render: (start_stream_time) => <FormattedDateTime date={start_stream_time}/>
    },
    {
      title: (
        <FormattedMessage
          id="app.end_date"
          defaultMessage={`End Date`}
        />
      ),
      align: "center",
      width: 100,
      dataIndex: "end_stream_time",
      key: "end_stream_time",
      render: (end_stream_time) => <FormattedDateTime date={end_stream_time}/>
    },
    {
      title: <FormattedMessage id="app.active_status" defaultMessage={`Active status`}/>,
      align: 'center',
      width: 50,
      dataIndex: "is_active",
      key: "is_active",
      render: (is_active) => <FormattedMessage id={is_active ? `app.active` : 'app.inactive'}
                                               defaultMessage={is_active ? `Active` : 'Inactive'}/>
    },
    {
      title: <FormattedMessage id="app.conductor_status" defaultMessage={`Conductor status`}/>,
      align: 'center',
      width: 50,
      dataIndex: "status",
      key: "status",
      render: (status) => handleStatusTitle(status)
    },
    {
      title: <FormattedMessage id="app.action" defaultMessage={`Action`}/>,
      align: "center",
      key: "actions",
      width: 90,
      dataIndex: "actions",
      render: (text, record) => (
        <span>
          <NavLink to={`/conductors/${record.id}/edit`}>
            <Button type="link" size={`small`}>
              <FormattedMessage id="app.edit" defaultMessage={`Edit`}/>
            </Button>
          </NavLink>

          <Divider type="vertical" size={`small`}/>

          <Button
            type="link"
            className={`danger`}
            onClick={() => deleteConductor(record)}
          >
            <FormattedMessage id="app.delete" defaultMessage={`Delete`}/>
          </Button>
        </span>
      )
    }
  ];

  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(ConductorsTable);
